import React from 'react';
import PropTypes from 'prop-types';

import { DealerNavigation } from './MenuItems';
import { NavigationItem } from './NavigationItem/NavigationItem';
import { NavigationPaneSt } from './NavigationPane.css';

export class NavigationPane extends React.PureComponent {
  renderNavigationItem = (item, idx) => {
    const { currentPath, onNavigationItemClick } = this.props;
    const { subNav } = item;
    const childActive =
      subNav && subNav.find((item) => item.to === currentPath);
    const isActive = item.paths && item.paths.includes(currentPath);

    const onClick = () => {
      if (item.onClick && typeof item.onClick === 'function') {
        item.onClick();
      }
      onNavigationItemClick();
    };

    return (
      <NavigationItem
        {...item}
        key={idx}
        isActive={isActive || childActive !== undefined}
        onClick={onClick}
      >
        {subNav &&
          subNav.map((subItem, subIdx) => {
            if (subItem.isDisabled) {
              return null;
            }

            const isActive =
              subItem.paths && subItem.paths.includes(currentPath);

            return (
              <NavigationItem
                {...subItem}
                key={subIdx}
                isActive={isActive}
                isSubItem
                onClick={onNavigationItemClick}
              />
            );
          })}
      </NavigationItem>
    );
  };

  render() {
    const { currentPath, logout, network } = this.props;
    const menuItems = DealerNavigation({ currentPath, logout, network });

    return (
      <NavigationPaneSt>
        {menuItems.map(this.renderNavigationItem)}
      </NavigationPaneSt>
    );
  }
}

NavigationPane.propTypes = {
  authorities: PropTypes.arrayOf(PropTypes.string),
  currentPath: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  network: PropTypes.object.isRequired,
  onNavigationItemClick: PropTypes.func,
  userLoggedIn: PropTypes.bool,
  target: PropTypes.string.isRequired,
};

NavigationPane.defaultProps = {
  authorities: [],
  onNavigationItemClick: () => {},
  userLoggedIn: false,
};
